function initHeader() {

  // slider promo banner

  var $promoBanner = $('.promo-banner');

  $promoBanner.flickity({
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    cellAlign: 'center',
    autoPlay: 4500
  });

  $promoBanner.outerHeight();

  var $header = $('header.header'),
      $main = $('.main-content'),
      headerHeight = $header.outerHeight(),
      offset = $('section.promo-banner').outerHeight() * 2;

  // if (!isMobile) {

    var h = document.querySelector('header.header'),
        headroom  = new Headroom(h, {
          offset: offset,
          tolerance: {
            up: 30,
            down: 0
          },
          classes: {
            initial: 'hr',
            pinned: 'header--pin',
            unpinned: 'header--unpin',
            top: 'header--top',
            notTop: 'header--not-top',
            bottom: 'header--bot',
            notBottom: 'header--not-bot'
          },
        });

    headroom.init();

  // }

  $main.css('padding-top', headerHeight).data('offset', headerHeight).addClass('loaded');

}
